import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminSosService } from '../../core/services/admin-sos.service';
import { SosAlert } from '../../core/models/admin.models';

@Component({
  selector: 'app-sos-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './sos-list.component.html'
})
export class SosListComponent implements OnInit {
  alerts: SosAlert[] = [];
  isLoading = false;
  errorMessage = '';
  updatingAlertId: number | null = null;

  constructor(private sosService: AdminSosService) {}

  ngOnInit() {
    this.loadAlerts();
  }

  loadAlerts() {
    this.isLoading = true;
    this.errorMessage = '';

    this.sosService.getSosAlerts().subscribe({
      next: (res) => {
        this.alerts = Array.isArray(res) ? res : (res as any).data ?? [];
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load SOS alerts.';
        this.isLoading = false;
      }
    });
  }

  resolveAlert(alert: SosAlert) {
    if(confirm('Mark this SOS alert as resolved?')) {
      this.updatingAlertId = alert.id;
      this.sosService.updateSosStatus(alert.id, 'resolved').subscribe({
        next: () => {
          alert.status = 'resolved';
          this.updatingAlertId = null;
        },
        error: (err) => {
          console.error(err);
          this.errorMessage = 'Failed to resolve SOS alert.';
          this.updatingAlertId = null;
        }
      });
    }
  }
}
